import { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import appContext from "../../context/appContext";

const SideBarItem = ({ title, icon, showTitle, link }) => {
  const location = useLocation();
  const { collapse } = useContext(appContext);

  return (
    <Link to={link} className={` py-1  text-decoration-none`}>
      <div
        className={`${
          location.pathname === link
            ? " sideBarItem__selected"
            : "sideBarItem__not__selected"
        }  sideBarItem d-flex text-nowrap  `}
      >
        <div
          className={`sideBarItem__icon p-2 ${
            showTitle ? "icon__left" : "icon__center"
          }`}
        >
          {icon}
        </div>
        <div
          className={`title  d-grid align-items-center ${
            collapse ? "showTitle" : "hideTitle"
          }`}
        >
          {title}
        </div>
      </div>
    </Link>
  );
};

export default SideBarItem;
